<template>
    <div class="user_index no-trans" v-loading="loading">
        <div class="user_index_box">
             <div class="title_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <router-link class="span1 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/home">首页</router-link> > <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/user_grzx">个人中心</router-link>
                <span class="span2" v-if="path_title">> {{path_title}}</span>
             </div>
             <div class="index_flex">
                <div class="lefts">
                    <div class="item1" v-for="(item1,index1) in path_list" :key="index1">
                        <div class="item_title">{{ item1.title }}</div>
                        <div class="item_list">
                            <div class="item_item" v-for="(item2,index2) in item1.list" :key="index2" :class="{'item_item_ac':path_ac==item2.id}" @click="handle_path(item2)">
                                <div class="item_name">{{ item2.title }}</div>
                                <div class="item_bg">
                                </div>
                                <div class="item_borders"></div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="rights">
                     <div class="rights_tops">
                        {{ path_detia.title||"" }}
                     </div>
                     <div class="rights_boms">
                        <div v-html="path_detia.content"></div>
                     </div>
                </div>
             </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
 


export default {
    components: {
       
    },
    name: "homes",
    data() {
        return {
            loading:false,
            path_title:'',
            path_ac:'1',
            path_list:[
             
            ],
            path_detia:{}
        }
    },
    computed: {
       
    },
    watch: {
        $route:{
            handler(newVal, oldVal) {
                console.log(newVal)
                
                if(newVal.meta.title!='个人中心'){

                    this.path_title=newVal.meta.title
                }else{
                    this.path_title=''
                }
           
            },
            immediate: true,
            deep: true
        },

        // path_ac
    },
    created() {
        this.get_path_list()
    },
    methods: {
        get_path_list(){
            this.loading = true
            this.$api("getArticleCategoryList", {
                parent_id:15,
                
			}, "get").then((res) => {
                this.loading = false
                console.log('帮助中心分类',res)
                if (res.code == 1) {
                   let list=res.data
                   list.forEach((e,i)=>{
                   
                    e.list=[]
                    this.get_new_list(e,i)
                   })
                   this.path_list=list
                } else {
                    alertErr(res.msg)
                }
            });

        },
        get_new_list(e,i){
            this.loading = true
            this.$api("getArticleList", {
                category_id:e.id,
                limit:9999,
			}, "get").then((res) => {
                this.loading = false
                console.log('帮助中心列表',res)
                if (res.code == 1) {
                   e.list=res.data.list
                   if(i==0){
                        this.path_ac=res.data.list[0].id
                        this.get_detial()
                    }
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_path(item){
           this.path_ac=item.id
           this.get_detial()
        },
        get_detial(){
            this.loading = true
            this.$api("getArticle", {
              id:this.path_ac,
			}, "get").then((res) => {
                this.loading = false
                console.log('帮助中心列表详情',res)
                if (res.code == 1) {
                    this.path_detia=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
      



    },

}
</script>
<style scoped lang="less">
.user_index{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    padding:21px ;
    padding-bottom: 100px;
    .user_index_box{
        width: 1440px;
        margin: auto;
        .title_box{
            padding-bottom: 21px;

            display: flex;
            align-items: center;

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            .span1{
                cursor: pointer;
                margin-right: 10px;
            }
            .span2{
                cursor: pointer;
                margin-left: 10px;
            }
            img{
                margin-right: 10px;
                width: 14px;
            }
        }
        .index_flex{
            display: flex;
            align-content: end;
            justify-content: space-between;
            .lefts{
                width: 220px;
                height: 700px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                padding: 16px 0;
                .item_title{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #8C959E;
                    margin-bottom: 8px;
                    padding: 0 24px;
                }
                .item_list{
                    padding-bottom: 20px;
                    .item_item{
                        padding: 0 24px;
                        width: 220px;
                        height: 36px;
                        // background: #377CFD;
                        // border-radius: 0px 0px 0px 0px;
                        // opacity: 0.04;
                        position: relative;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        .item_img{
                            .img1{
                                display: inline;
                            }
                            .img2{
                                display: none;
                            }
                            img{
                                width: 12px;
                                // height: 14px;
                            }
                        }
                        .item_name{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }
                        .item_bg{
                            width: 220px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 0px 0px 0px 0px;
                            opacity: 0.04;
                            position: absolute;
                            top: 0;
                            left: 0;
                            display: none;
                        }
                        .item_borders{
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 4px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 0px 0px 0px 0px;
                            display: none;

                        }
                        &:hover{
                            color: #377CFD;
                            .item_img{
                                .img1{
                                    display: none;
                                }
                                .img2{
                                    display:inline ;
                                }
                            }
                            .item_bg{
                                display: inline;
                            }
                            .item_borders{
                                display: inline;
                            }
                        }

                       
                    }
                    .item_item_ac{
                        color: #377CFD;
                        .item_img{
                            .img1{
                                display: none;
                            }
                            .img2{
                                display:inline ;
                            }
                        }
                        .item_bg{
                            display: inline;
                        }
                        .item_borders{
                            display: inline;
                        }
                    }
                }

            }
            .rights{
                width: 1196px;
                // height: 100px;
                // background-color: red;
                .rights_tops{
                    width: 1196px;
                    height: 56px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    padding-left: 32px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 16px;
                    color: #333333;
                    line-height: 56px;
                }
                .rights_boms{
                    margin-top: 24px;
                    background: #FFFFFF;
                    padding: 32px;
                }
            }
            
        }
        
    }
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_index.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding: 16px;
        padding-bottom: 16px;
    }
    .user_index.no-trans .user_index_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .user_index.no-trans .user_index_box .title_box {
        padding-bottom: 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .user_index.no-trans .user_index_box .title_box .span1 {
        margin-right: 10px;
    }
    .user_index.no-trans .user_index_box .title_box .span2 {
        margin-left: 10px;
    }
    .user_index.no-trans .user_index_box .title_box img {
        margin-right: 10px;
        width: 14px;
    }
    .user_index.no-trans .user_index_box .index_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_index.no-trans .user_index_box .index_flex .lefts {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        padding: 16px 0;
    }
    .user_index.no-trans .user_index_box .index_flex .lefts .item_title {
        font-size: 14px;
        margin-bottom: 8px;
        padding: 0 16px;
    }
    .user_index.no-trans .user_index_box .index_flex .lefts .item_list {
        padding-bottom: 16px;
    }
    .user_index.no-trans .user_index_box .index_flex .lefts .item_list .item_item {
        padding: 0 16px;
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        flex-wrap: wrap;
        gap: 8px;
        min-height: 36px;
    }
    .user_index.no-trans .user_index_box .index_flex .lefts .item_list .item_item .item_img img {
        width: 12px;
    }
    .user_index.no-trans .user_index_box .index_flex .lefts .item_list .item_item .item_name {
        font-size: 14px;
    }
    .user_index.no-trans .user_index_box .index_flex .lefts .item_list .item_item .item_bg {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 36px;
        border-radius: 0px 0px 0px 0px;
    }
    .user_index.no-trans .user_index_box .index_flex .lefts .item_list .item_item .item_borders {
        width: 4px;
        height: 36px;
        border-radius: 0px 0px 0px 0px;
    }
    .user_index.no-trans .user_index_box .index_flex .rights {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_index.no-trans .user_index_box .index_flex .rights .rights_tops {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding-left: 16px;
        font-size: 16px;
        line-height: 1.6;
    }
    .user_index.no-trans .user_index_box .index_flex .rights .rights_boms {
        margin-top: 16px;
        padding: 16px;
    }
}
</style>
